export default class CustomizeCtrl {
    constructor($scope, $state, $filter, Events, SweetAlert, SideMenu, Customization) {
        SideMenu.setActive('subscriber');

        this._state = $state;
        this._filter = $filter;

        this.customizationRepo = Customization;
        this.sweetAlert = SweetAlert;
        this.eventHandler = Events;

        this.customizationRepo.allGroups().then((groups) => {
            this.groups = groups.data;
        });

    }
    createGroup() {

        let groupNames = this.groups.map(group => group.name);
        let newGroupName = this._filter('getNumberedName')(groupNames, 'New');

        this.customizationRepo.storeGroup(newGroupName).then(() => {
            this._state.go(this._state.current.name, this._state.params, { reload: true });
        }, (error) => {
            if (error.data.code === 9) {
                this.sweetAlert.swal({
                    title: this._filter('translate')('GLOBAL:FLASH:OOPS'),
                    text: this._filter('translate')('CUSTOMIZE:FLASH:DUPLICATE_GROUP_CREATE'),
                    type: 'error'
                });
            } else {
                this.sweetAlert.swal({
                    title: this._filter('translate')('GLOBAL:FLASH:OOPS'),
                    text: this._filter('translate')('CUSTOMIZE:FLASH:CREATE_GROUP_ERROR'),
                    type: 'error'
                });
            }
        });
    };

    showGroup(group) {
        this._state.go('subscriber.group', { id: group.id });
    };

    showCreateFieldBtn() {
        this.settings.showCreateField = false;
    };

    updateGroup(group) {
        this.customizationRepo.updateGroup(group).then(() => {
            // Do nothing.
        }, (error) => {
            var translation, message;
            var title = this._filter('translate')('GLOBAL:FLASH:OOPS');

            if (error.data && error.data.code == 400) {
                translation = this._filter('translate')('CUSTOMIZE:FLASH:DUPLICATE_GROUP_UPDATE');
                message = translation.replace(/:name/,  group.name);
                this.sweetAlert.swal(title, message, 'error');
            } else if (error.data && error.data.code === 11) {
                message = this._filter('translate')('CUSTOMIZE:FLASH:GROUP_DATA_IS_DELETING');
                this.sweetAlert.swal(title, message, 'error');
            } else if (error.data.name) {
                message = this._filter('translate')('CUSTOMIZE:FLASH:ERROR:INVALID_GROUP_NAME');
                this.sweetAlert.swal(title, message, 'error');
            } else {
                this.sweetAlert.swal({
                    title: this._filter('translate')('GLOBAL:FLASH:OOPS'),
                    text: this._filter('translate')('CUSTOMIZE:FLASH:UPDATE_GROUP_ERROR'),
                    type: 'error'
                });
            }
        })
    };

    removeGroup(group, index) {
        this.sweetAlert.swal({
                title: this._filter('translate')('CUSTOMIZE_MODAL:DELETE:DELETE_GROUP_TITLE'),
                text: this._filter('translate')('CUSTOMIZE_MODAL:DELETE:DELETE_GROUP_EXPLAINED'),
                type: 'warning',
                customClass: 'sweet-alert--delete',
                showCancelButton: true,
                confirmButtonText: this._filter('translate')('GLOBAL:YES'),
                cancelButtonText: this._filter('translate')('GLOBAL:NO')
            }, (isConfirm) => {
                if (isConfirm) {
                    this.customizationRepo.removeGroup(group).then(() => {
                        this.groups.splice(index, 1);
                    });
                }
            }
        )
    };

    toggleHistorical(group) {
        var text = group.historical ? 'CUSTOMIZE:GROUP:MAKE_NON_HISTORICAL' : 'CUSTOMIZE:GROUP:MAKE_HISTORICAL';
        var title = group.historical ? 'CUSTOMIZE:GROUP:TOGGLE_HISTORICAL:HEADER' : 'CUSTOMIZE:GROUP:TOGGLE_NON_HISTORICAL:HEADER';

        this.sweetAlert.swal({
            title: this._filter('translate')(title),
            text: this._filter('translate')(text),
            type: 'warning',
            customClass: group.historical ? 'sweet-alert--delete' : '',
            showCancelButton: true,
            cancelButtonText: this._filter('translate')('GLOBAL:NO'),
            confirmButtonText: this._filter('translate')('GLOBAL:YES')
        }, (isConfirm) => {
            if (isConfirm) {
                group.historical = !group.historical;

                this.customizationRepo.updateGroup(group).then(() => {
                    this.eventHandler.flashEvent('notification', this._filter('translate')('CUSTOMIZE:FLASH:GROUP_UPDATED'));
                }, (error) => {

                    if (error.data && error.data.code === 11) {
                        let message = this._filter('translate')('CUSTOMIZE:FLASH:GROUP_DATA_IS_DELETING');
                        this.sweetAlert.swal(this._filter('translate')('GLOBAL:FLASH:OOPS'), message, 'error');
                    } else {
                        this.sweetAlert.swal({
                            title: this._filter('translate')('GLOBAL:FLASH:OOPS'),
                            text: this._filter('translate')('CUSTOMIZE:FLASH:UPDATE_GROUP_ERROR'),
                            type: 'error'
                        });
                    }

                    group.historical = !group.historical;
                });
            }
        });
    };
};

